import { all, put, takeLatest } from 'redux-saga/effects';
import { CONFIG } from '~/config';

import { ExternalRestClient } from '~/modules/requests';

import {
  fetchRecommendedCurrency,
  fetchRecommendedCurrencySuccess,
  fetchRecommendedCurrencyFailure,
} from '~/actions';
import { ApiResponse } from '~/types';

export function* fetchRecommendedCurrencySaga() {
  try {
    const response: ApiResponse<any> = yield ExternalRestClient.get(
      `${CONFIG.env.apiBaseUrl}v1/recommendations`
    );

    if (response.status === 200 && response.data?.country?.recommendedCurrency?.code) {
      const recommendedCurrency = response.data.country.recommendedCurrency.code;
      yield put(fetchRecommendedCurrencySuccess(recommendedCurrency));
    } else {
      yield put(fetchRecommendedCurrencyFailure());
    }
  } catch (error: any) {
    // Default to USD on error
    yield put(fetchRecommendedCurrencyFailure());
  }
}

/**
 * Recommendations Sagas
 */
export default function* root() {
  yield all([takeLatest(fetchRecommendedCurrency.type, fetchRecommendedCurrencySaga)]);
}
